<script setup lang="ts">
import { APP_NAME } from '@/constants';
import { useAppStore } from '@/store/app';

const appStore = useAppStore();
const { t } = useI18n();

useHead({
	title: `${APP_NAME} | ${t('error')}`,
});

const handleError = () => {
	clearError({ redirect: '/' });
};

watchEffect(() => {
	appStore.title = `${APP_NAME} | ${t('error')}`;
});
</script>

<template>
	<main class="error-page">
		<img class="img-500" src="/images/500.svg" alt="Error" />
		<div class="title">{{ $t('errorPage.title') }}</div>
		<div class="sub-title">
			<p>{{ $t('errorPage.description') }}</p>
			<p>{{ $t('errorPage.description2') }}</p>
		</div>
		<el-button type="primary" @click="handleError">
			<span>{{ $t('errorPage.goBack') }}</span>
		</el-button>
	</main>
</template>
<style lang="scss" scoped>
@import '@/assets/scss/pages/error.scss';
</style>
